export default __webpack_public_path__ + "assets/pdf/SGN_BR_Results_PTGuide_20251229_NAT-8022747_DWNLD.pdf";